<!-- Parent Component Template -->
<template>
  <div>
    <woot-modal-header :header-title="filterModalHeaderTitle">
      <p class="text-slate-600 dark:text-slate-200">
        {{ filterModalSubTitle }}
      </p>
    </woot-modal-header>
    <div class="p-8">
      <div v-if="isSegmentsView">
        <label class="input-label" :class="{ error: !activeSegmentNewName }">
          {{ $t('CONTACTS_FILTER.SEGMENT_LABEL') }}
          <input
            v-model="activeSegmentNewName"
            type="text"
            class="folder-input border-slate-75 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100"
          />
          <span v-if="!activeSegmentNewName" class="message">
            {{ $t('CONTACTS_FILTER.EMPTY_VALUE_ERROR') }}
          </span>
        </label>
        <label class="input-label">
          {{ $t('CONTACTS_FILTER.SEGMENT_QUERY_LABEL') }}
        </label>
      </div>
      <div
        class="p-4 rounded-lg bg-slate-25 dark:bg-slate-900 border border-solid border-slate-50 dark:border-slate-700/50 mb-4"
      >
        <div
          v-for="(group, groupIndex) in groupedAppliedFilters"
          :key="`filter-group-${group.id}`"
        >
          <div class="filter-group-container">
            <div
              v-if="usesExplicitFilterGroups"
              class="filter-group-label"
            >
              {{ $t('CONTACTS_FILTER.GROUP_LABEL', { number: groupIndex + 1 }) }}
            </div>
            <filter-input-box
              v-for="item in group.items"
              :key="item.index"
              v-model="appliedFilters[item.index]"
              :filter-groups="filterGroups"
              :grouped-filters="true"
              :input-type="
                getInputType(
                  appliedFilters[item.index].attribute_key,
                  appliedFilters[item.index].filter_operator
                )
              "
              :operators="getOperators(appliedFilters[item.index].attribute_key)"
              :dropdown-values="
                getDropdownValues(appliedFilters[item.index].attribute_key)
              "
              :show-query-operator="showQueryOperatorForFilter(item, group)"
              :show-user-input="
                showUserInput(appliedFilters[item.index].filter_operator)
              "
              :v="$v.appliedFilters.$each[item.index]"
              @resetFilter="resetFilter(item.index, appliedFilters[item.index])"
              @removeFilter="removeFilter(item.index)"
              @phoneNumberError="phoneNumberError = $event"
              @validEmailError="validEmailError = $event"
            />
            <div class="mt-3">
              <woot-button
                icon="add"
                color-scheme="success"
                variant="smooth"
                size="small"
                @click="appendNewFilterToGroup(group.id)"
              >
                {{ $t('CONTACTS_FILTER.ADD_NEW_FILTER') }}
              </woot-button>
            </div>
          </div>
          <div
            v-if="showGroupConnector(groupIndex)"
            class="filter-group-connector"
          >
            <hr
              class="filter-group-connector-line border-b border-solid border-slate-75 dark:border-slate-800"
            />
            <select
              v-model="
                appliedFilters[groupConnectorFilterIndex(group)].query_operator
              "
              class="filter-group-connector-select bg-white dark:bg-slate-900 mb-0 w-auto relative text-slate-800 dark:text-slate-100 border-slate-75 dark:border-slate-600"
            >
              <option value="and">
                {{ $t('CONTACTS_FILTER.QUERY_DROPDOWN_LABELS.AND') }}
              </option>
              <option value="or">
                {{ $t('CONTACTS_FILTER.QUERY_DROPDOWN_LABELS.OR') }}
              </option>
            </select>
          </div>
        </div>
        <div class="mt-4 flex gap-2">
          <woot-button
            icon="add-circle"
            color-scheme="secondary"
            variant="smooth"
            size="small"
            @click="appendNewFilterGroup"
          >
            {{ $t('CONTACTS_FILTER.ADD_NEW_GROUP') }}
          </woot-button>



          <woot-button
            v-if="isActionsFiltersFeatureEnabled"
            icon="add"
            color-scheme="success"
            variant="smooth"
            size="small"
            @click="appendNewAction"
          >
            <!-- {{ $t('FILTER.ADD_NEW_FILTER') }} -->
              Action
          </woot-button>




          <woot-button
            v-if="hasAppliedFilters && !isSegmentsView"
            icon="subtract"
            color-scheme="alert"
            variant="smooth"
            size="small"
            @click="clearFilters"
          >
            {{ $t('CONTACTS_FILTER.CLEAR_ALL_FILTERS') }}
          </woot-button>

        </div>
      </div>
      
      <div 
          class="mt-3"
          v-if="isActions">
          <p class="actions_box">Actions</p>
            <filter-input-box
              v-for="(action, i) in appliedActions"
              :key="'action-' + i"
              v-model="appliedActions[i]"
              :filter-groups="actionGroup"
              :is-actions="isActions"
              :hide-operator-select="
                hideActionOperatorSelect(appliedActions[i].attribute_key)
              "
              :input-type="
                getInputActionsType(
                  appliedActions[i].attribute_key,
                  appliedActions[i].filter_operator
                )
              "
              :operators="getActionsOperators(appliedActions[i].attribute_key)"
              :dropdown-values="
            getDropdownValues(appliedActions[i].attribute_key, {
              forActions: true,
            })
          "
              :show-query-operator="i !== appliedActions.length - 1"
              :show-user-input="
                showUserInput(
                  appliedActions[i].filter_operator,
                  appliedActions[i].attribute_key
                )
              "
              :grouped-filters="true"
              :v="$v.appliedActions.$each[i]" 
              @resetFilter="resetAction(i)"
              @removeFilter="removeAction(i)"
            />
      </div>

      <div class="w-full">
        <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
          <woot-button class="button clear" @click.prevent="onClose">
            {{ $t('CONTACTS_FILTER.CANCEL_BUTTON_LABEL') }}
          </woot-button>
          <woot-button
            v-if="isSegmentsView"
            :disabled="!activeSegmentNewName"
            @click="updateSegment"
          >
            {{ $t('CONTACTS_FILTER.UPDATE_BUTTON_LABEL') }}
          </woot-button>
          <woot-button
            v-else
            :disabled="phoneNumberError || validEmailError"
            @click="submitFilterQuery"
          >
            {{ $t('CONTACTS_FILTER.SUBMIT_BUTTON_LABEL') }}
          </woot-button>
        </div>
      </div>
    </div>
    <div class="action-confirm-host">
      <woot-confirm-modal
        ref="actionConfirmDialog"
        :title="$t('CONTACTS_FILTER.ACTION_CONFIRM.TITLE')"
        :description="$t('CONTACTS_FILTER.ACTION_CONFIRM.DESCRIPTION')"
        :confirm-label="$t('CONTACTS_FILTER.ACTION_CONFIRM.CONFIRM')"
        :cancel-label="$t('CONTACTS_FILTER.ACTION_CONFIRM.CANCEL')"
      />
    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { required, requiredIf } from 'vuelidate/lib/validators';
import axios from 'axios';
import FilterInputBox from '../../../../components/widgets/FilterInput/Index.vue';
import countries from 'shared/constants/countries.js';
import { mapGetters, mapActions } from 'vuex';
import {
  filterAttributeGroups,
  UNASSIGNED_ASSIGNEE_ID,
} from '../contactFilterItems';
import {
  actionAttributeGroups,
  ACTION_KEYS_WITHOUT_VALUES,
  ACTION_KEYS_HIDE_OPERATOR,
} from '../contactActions';
import {
  aiEmailConfigErrorCode,
  defaultAiEmailActionValue,
} from 'dashboard/helper/aiEmailSchedule';

import filterMixin from 'shared/mixins/filterMixin';
import actionsContactMixin from 'shared/mixins/actionsContactMixin';
import * as OPERATORS from 'dashboard/components/widgets/FilterInput/FilterOperatorTypes.js';
import { CONTACTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import {
  DEFAULT_FILTER_GROUP_ID,
  assignFilterGroupId,
  groupFiltersForDisplay,
  lastFilterGroupId,
  nextFilterGroupId,
  normalizeFilterGroupIds,
  usesExplicitFilterGroups as hasExplicitFilterGroups,
} from '../../../../helper/filterGroupHelper';

export default {
  components: {
    FilterInputBox,
  },
  mixins: [alertMixin, filterMixin, actionsContactMixin],
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    initialFilterTypes: {
      type: Array,
      default: () => [],
    },
    initialActionTypes: {
      type: Array,
      default: () => [],
    },
    initialAppliedFilters: {
      type: Array,
      default: () => [],
    },
    isSegmentsView: {
      type: Boolean,
      default: false,
    },
    activeSegmentName: {
      type: String,
      default: '',
    },
    leads: {
      type: Array,
      default: () => [],
    },
    initialAppliedActions:{
      type: Array,
      default: ()=>[]
    },
    /** CRM states for the State (`state_id`) contact filter */
    statesForFilter: {
      type: Array,
      default: () => [],
    },
    isDailyTasksView: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    appliedFilters: {
      required,
      $each: {
        values: {
          required,
          ensureRelativeTimeRange(value, prop) {
            if (prop.filter_operator === 'last_x_hours') {
              const hours = Number(value);
              return Number.isInteger(hours) && hours >= 1 && hours <= 24;
            }
            if (prop.filter_operator === 'days_before') {
              return parseInt(value, 10) > 0 && parseInt(value, 10) < 999;
            }
            return true;
          },
        },
      },
    },
  appliedActions: {
    $each: {
      values: {
        required: requiredIf(prop => {
          if (prop.attribute_key === 'check_lead_quality') return false;
          if (
            prop.filter_operator === 'is_present' ||
            prop.filter_operator === 'is_not_present'
          ) {
            return false;
          }
          return true;
        }),
        aiGeneratedEmailActionValid(value, prop) {
          if (!prop || prop.attribute_key !== 'send_ai_generated_email') {
            return true;
          }
          return !aiEmailConfigErrorCode(value);
        },
      },
    },
  },
  },
  data() {
    return {
      show: true,
      appliedFilters: this.initialAppliedFilters,
      activeSegmentNewName: this.activeSegmentName,
      filterTypes: [
        ...this.initialFilterTypes,
        {
          attributeKey: 'assigned_agent',
          attributeI18nKey: 'CONTACTS_FILTER.ATTRIBUTES.ASSIGNED_AGENT',
          inputType: 'search_select',
          filterOperators: OPERATORS.OPERATOR_TYPES_1,
          attributeModel: 'standard',
        },
      ],
      actionTypes: [
        ...this.initialActionTypes,
        {
          attributeKey: 'assigned_agent',
          attributeI18nKey: 'CONTACTS_FILTER.ATTRIBUTES.ASSIGNED_AGENT',
          inputType: 'search_select',
          filterOperators: OPERATORS.OPERATOR_TYPES_1,
          attributeModel: 'standard',
        },
      ],
      filterGroups: [],
      allCustomAttributes: [],
      rawFilterAttributeGroups: filterAttributeGroups,
      attributeModel: 'contact_attribute',
      filtersFori18n: 'CONTACTS_FILTER',
      agents: [],
      /** CRM pipeline states for the State contact filter (loaded here like agents — avoids empty dropdown when modal mounts before parent fetch). */
      crmStates: [],
      isLoadingAgents: false,
      phoneNumberError: false,
      validEmailError: false,
      isActions: false,
      actionConfirmOpen: false,
      appliedActions: this.initialAppliedActions, 
      actionGroup:[],
      rawActionAttributes: actionAttributeGroups,
      /** Meta CAPI standard event names (from server catalog) for send_conversion_event action */
      metaStandardCapiEvents: [],
    };
  },
  computed: {
    ...mapGetters({
      boards: 'boards/getBoards',
      getAppliedContactFilters: 'contacts/getAppliedContactFilters',
      currentAccountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      getAppliedContactActions: 'contacts/getAppliedContactActions',   
      labels: 'labels/getLabels',
      campaigns: 'campaigns/getAllCampaigns',
      campaignStatuses: 'campaigns/getCampaignStatuses',
      isCampaignsLoading: 'campaigns/isCampaignsLoading',
      hasCampaignData: 'campaigns/hasCampaignData',
    }),
    hasAppliedFilters() {
      return this.getAppliedContactFilters.length;
    },
    groupedAppliedFilters() {
      return groupFiltersForDisplay(this.appliedFilters);
    },
    usesExplicitFilterGroups() {
      return hasExplicitFilterGroups(this.appliedFilters);
    },
    filterModalHeaderTitle() {
      return !this.isSegmentsView
        ? this.$t('CONTACTS_FILTER.TITLE')
        : this.$t('CONTACTS_FILTER.EDIT_CUSTOM_SEGMENT');
    },
    filterModalSubTitle() {
      return !this.isSegmentsView
        ? this.$t('CONTACTS_FILTER.SUBTITLE')
        : this.$t('CONTACTS_FILTER.CUSTOM_VIEWS_SUBTITLE');
    },
    isAgentBotsFeatureEnabledReminder() {
      return this.isFeatureEnabledonAccount(
        this.currentAccountId,
        FEATURE_FLAGS.FILTER_BOARD
      );
    },

    isActionsFiltersFeatureEnabled() {
      return this.isFeatureEnabledonAccount(
        this.currentAccountId,
        FEATURE_FLAGS.ACTIONS_FILTERS
      );
    },
    filterAttributeGroups() {
    const excludedKeys = ['prev_status_id'];

    return this.rawFilterAttributeGroups.map(group => ({
      ...group,
      attributes: !this.isAgentBotsFeatureEnabledReminder
        ? group.attributes.filter(attr => !excludedKeys.includes(attr.key))
        : group.attributes,
    }));
  },
    actionAttributeGroups() {
    return this.rawActionAttributes
      .map(group => ({
        ...group,
        attributes: group.attributes.filter(attr => {
          if (!attr.featureFlag) return true;
          return this.isFeatureEnabledonAccount(
            this.currentAccountId,
            attr.featureFlag
          );
        }),
      }))
      .filter(group => group.attributes.length > 0);
  },
  },
  watch: {
    metaStandardCapiEvents: {
      handler() {
        this.normalizeSendConversionEventValues();
      },
      deep: true,
    },
    filterAttributeGroups: {
      handler() {
        this.refreshFilterGroups();
      },
      deep: true,
    },
    initialFilterTypes: {
      handler(types) {
        this.filterTypes = [
          ...types,
          {
            attributeKey: 'assigned_agent',
            attributeI18nKey: 'CONTACTS_FILTER.ATTRIBUTES.ASSIGNED_AGENT',
            inputType: 'search_select',
            filterOperators: OPERATORS.OPERATOR_TYPES_1,
            attributeModel: 'standard',
          },
        ];
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.dispatch('boards/get');
    this.$store.dispatch('inboxes/get');
    this.$store.dispatch('macros/get');
    // Do not await agent/state fetches: blocking delayed setFilterAttributes and caused modal open flicker.
    this.fetchAgents();
    this.fetchCrmStates();
    this.fetchMetaConversionStandardEvents();

    this.refreshFilterGroups();
      this.setFilterAttributess();
      if (this.getAppliedContactFilters.length) {
        this.appliedFilters = [...this.getAppliedContactFilters];
      } else if (!this.isSegmentsView) {
        this.appliedFilters.push({
          attribute_key: 'name',
          filter_operator: 'equal_to',
          values: '',
          query_operator: 'and',
          attribute_model: 'standard',
        });
      }

      if (this.getAppliedContactActions?.length) {
        this.appliedActions = [...this.getAppliedContactActions];
        this.isActions = true;
        this.normalizeSendConversionEventValues();
    }
  },
  methods: {
    refreshFilterGroups() {
      const allCustomAttributes = this.$store.getters[
        'attributes/getAttributesByModel'
      ](this.attributeModel);
      const customAttributesFormatted = {
        name: this.$t(`${this.filtersFori18n}.GROUPS.CUSTOM_ATTRIBUTES`),
        attributes: allCustomAttributes.map(attr => ({
          key: attr.attribute_key,
          name: attr.attribute_display_name,
        })),
      };
      const allFilterGroups = this.filterAttributeGroups.map(group => ({
        name: this.$t(`${this.filtersFori18n}.GROUPS.${group.i18nGroup}`),
        attributes: group.attributes.map(attribute => ({
          key: attribute.key,
          name: this.$t(
            `${this.filtersFori18n}.ATTRIBUTES.${attribute.i18nKey}`
          ),
        })),
      }));
      const customAttributeTypes = allCustomAttributes.map(attr => ({
        attributeKey: attr.attribute_key,
        attributeI18nKey: `CUSTOM_ATTRIBUTE_${attr.attribute_display_type.toUpperCase()}`,
        inputType: this.customAttributeInputType(attr.attribute_display_type),
        filterOperators: this.getOperatorTypes(attr.attribute_display_type),
        attributeModel: 'custom_attributes',
      }));
      this.filterTypes = [
        ...this.initialFilterTypes,
        {
          attributeKey: 'assigned_agent',
          attributeI18nKey: 'CONTACTS_FILTER.ATTRIBUTES.ASSIGNED_AGENT',
          inputType: 'search_select',
          filterOperators: OPERATORS.OPERATOR_TYPES_1,
          attributeModel: 'standard',
        },
        ...customAttributeTypes,
      ];
      this.filterGroups = [...allFilterGroups, customAttributesFormatted];
    },
    /** Dashboard uses `window.axios` (APIHelper + auth); raw `axios` has no tokens and breaks API calls. */
    http() {
      if (typeof window !== 'undefined' && window.axios) {
        return window.axios;
      }
      return axios;
    },
    defaultMetaCapiEventSelection() {
      return this.metaStandardCapiEvents?.[0] || null;
    },
    /** Ensure send_conversion_event rows have a selected event when the server catalog is loaded. */
    normalizeSendConversionEventValues() {
      const opts = Array.isArray(this.metaStandardCapiEvents)
        ? this.metaStandardCapiEvents
        : [];
      const fallback = opts[0] || null;
      if (!fallback) return;
      (this.appliedActions || []).forEach((action, index) => {
        if (action.attribute_key !== 'send_conversion_event') return;
        const v = action.values;
        const missing =
          v == null ||
          (typeof v === 'object' &&
            !String(v.id != null ? v.id : '').trim() &&
            !String(v.name != null ? v.name : '').trim());
        if (missing) {
          this.$set(this.appliedActions, index, {
            ...action,
            values: fallback,
            filter_operator: 'equal_to',
          });
        }
      });
    },
    async fetchAgents() {
      try {
        const response = await this.http().get(
          `/api/v1/accounts/${this.currentAccountId}/agents`
        );
        this.agents = response.data.map(agent => ({
          id: agent.id,
          name: agent.name,
        }));
      } catch (error) {
        this.showAlert(this.$t('CONTACTS_FILTER.AGENT_FETCH_ERROR'));
        this.agents = [];
      }
    },
    async fetchCrmStates() {
      const accountId = this.currentAccountId;
      if (accountId == null || String(accountId).trim() === '') {
        this.crmStates = [];
        return;
      }
      try {
        const { data } = await this.http().get(
          `/api/v1/accounts/${accountId}/states`,
          { params: { only_data: 'true' } }
        );
        const rows = data.states_data || [];
        this.crmStates = rows
          .filter(s => s && s.id != null)
          .map(s => ({ id: s.id, name: s.name }));
      } catch (error) {
        console.error('Error fetching CRM states:', error);
        this.crmStates = [];
      }
    },
    async fetchMetaConversionStandardEvents() {
      const accountId = this.currentAccountId;
      if (accountId == null || String(accountId).trim() === '') {
        this.metaStandardCapiEvents = [];
        this.normalizeSendConversionEventValues();
        return;
      }
      if (
        !this.isFeatureEnabledonAccount(
          accountId,
          FEATURE_FLAGS.META_CONVERSION_BOARD_SYNC
        )
      ) {
        this.metaStandardCapiEvents = [];
        this.normalizeSendConversionEventValues();
        return;
      }
      try {
        const { data } = await this.http().get(
          `/api/v1/accounts/${accountId}/meta_conversion_stages`
        );
        const rawList = data.standard_events || data.standardEvents || [];
        const list = Array.isArray(rawList) ? rawList : [];
        this.metaStandardCapiEvents = list.map(name => ({
          id: name,
          name,
        }));
        if (!this.metaStandardCapiEvents.length) {
          this.showAlert(this.$t('CONTACTS_FILTER.META_EVENTS_FETCH_ERROR'));
        }
      } catch (error) {
        this.metaStandardCapiEvents = [];
        this.showAlert(this.$t('CONTACTS_FILTER.META_EVENTS_FETCH_ERROR'));
      }
      this.normalizeSendConversionEventValues();
    },
    hideActionOperatorSelect(attributeKey) {
      return ACTION_KEYS_HIDE_OPERATOR.includes(attributeKey);
    },
    async fetchCampaigns() {
      try {
        await this.$store.dispatch('campaigns/fetchCampaignFilterOptions');
      } catch (error) {
        this.showAlert('Error fetching campaign options: ' + (error.message || 'Unknown error'));
      }
    },
    getOperatorTypes(key) {
      switch (key) {
        case 'list':
          return OPERATORS.OPERATOR_TYPES_1;
        case 'text':
          return OPERATORS.OPERATOR_TYPES_3;
        case 'number':
          return OPERATORS.OPERATOR_TYPES_1;
        case 'link':
          return OPERATORS.OPERATOR_TYPES_1;
        case 'date':
          return OPERATORS.OPERATOR_TYPES_4;
        case 'checkbox':
          return OPERATORS.OPERATOR_TYPES_1;
        default:
          return OPERATORS.OPERATOR_TYPES_1;
      }
    },
    customAttributeInputType(key) {
      switch (key) {
        case 'date':
          return 'date';
        case 'text':
          return 'plain_text';
        case 'list':
          return 'search_select';
        case 'checkbox':
          return 'search_select';
        default:
          return 'plain_text';
      }
    },
    getAttributeModel(key) {
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type.attributeModel;
    },
    getInputType(key, operator) {
      if (key === 'created_at' || key === 'last_activity_at') {
        if (operator === 'days_before' || operator === 'last_x_hours')
          return 'plain_text';
        if (key === 'created_at') return 'datetime';
        return 'date';
      }
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type?.inputType;
    },
    getOperators(key) {
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type?.filterOperators;
    },
    getActionsOperators(key) {
      const type = this.actionTypes.find(filter => filter.attributeKey === key);
      return type?.filterOperators;
    },
    getInputActionsType(key, operator) {
      if (key === 'created_at' || key === 'last_activity_at') {
        if (operator === 'days_before' || operator === 'last_x_hours')
          return 'plain_text';
        if (key === 'created_at') return 'datetime';
        return 'date';
      }
      const type = this.actionTypes.find(filter => filter.attributeKey === key);
      return type?.inputType;
    },
    getDropdownValues(type, { forActions = false } = {}) {
      if (type === 'assignee_id') {
        if (forActions) {
          return this.agents;
        }

        return [
          {
            id: UNASSIGNED_ASSIGNEE_ID,
            name: this.$t('CONTACTS_FILTER.UNASSIGNED'),
          },
          ...this.agents,
        ];
      }
      if (type === 'labels_id') {
        return this.labels.map(lab=>({id:lab.id, 
          name:lab.title}));
      }
      if (type === 'state_id') {
        if (Array.isArray(this.crmStates) && this.crmStates.length) {
          return this.crmStates;
        }
        return Array.isArray(this.statesForFilter) ? this.statesForFilter : [];
      }

      if (type === 'board_id') {
        return this.boards.map(board => ({
          id: board.id,
          name: board.name,
          statuses_attributes: board.statuses_attributes,
        }));
      }
      if (type === 'is_secondary') {
        return [{ id: 'true', name: 'True' }];
      }

      if (type === 'daily_task_status') {
        return [
          { id: 'pending', name: 'Pending' },
          { id: 'completed', name: 'Completed' },
        ];
      }

      if (type === 'prev_status_id') {
        return this.boards.map(board => ({
          id: board.id,
          name: board.name,
          statuses_attributes: board.statuses_attributes,
        }));
      }

      if (type === 'last_activity_by') {
        return this.leads?.map(lead => ({
          id: lead.id,
          name: lead.name,
        }));
      }

      if (type === 'campaign_id') {
        if (!Array.isArray(this.campaigns)) {
          return [];
        }
        return this.campaigns.map(campaign => ({
          id: campaign.id,
          name: campaign.name,
          statuses_attributes: campaign.statuses_attributes || this.campaignStatuses
        }));
      }
      if (type === 'send_conversion_event') {
        return Array.isArray(this.metaStandardCapiEvents)
          ? this.metaStandardCapiEvents
          : [];
      }
      const allCustomAttributes = this.$store.getters[
        'attributes/getAttributesByModel'
      ](this.attributeModel);
      const isCustomAttributeCheckbox = allCustomAttributes.find(attr => {
        return (
          attr.attribute_key === type &&
          attr.attribute_display_type === 'checkbox'
        );
      });
      if (isCustomAttributeCheckbox) {
        return [
          {
            id: true,
            name: this.$t('FILTER.ATTRIBUTE_LABELS.TRUE'),
          },
          {
            id: false,
            name: this.$t('FILTER.ATTRIBUTE_LABELS.FALSE'),
          },
        ];
      }

      const isCustomAttributeList = allCustomAttributes.find(attr => {
        return (
          attr.attribute_key === type && attr.attribute_display_type === 'list'
        );
      });

      if (isCustomAttributeList) {
        return allCustomAttributes
          .find(attr => attr.attribute_key === type)
          .attribute_values.map(item => {
            return {
              id: item,
              name: item,
            };
          });
      }
      switch (type) {
        case 'country_code':
          return countries;
        default:
          return undefined;
      }
    },
    showQueryOperatorForFilter(item, group) {
      const positionInGroup = group.items.findIndex(
        groupItem => groupItem.index === item.index
      );
      const isLastInGroup = positionInGroup === group.items.length - 1;

      if (!this.usesExplicitFilterGroups) {
        return item.index !== this.appliedFilters.length - 1;
      }

      return !isLastInGroup;
    },
    showGroupConnector(groupIndex) {
      return (
        this.usesExplicitFilterGroups &&
        groupIndex < this.groupedAppliedFilters.length - 1
      );
    },
    groupConnectorFilterIndex(group) {
      return group.items[group.items.length - 1].index;
    },
    buildEmptyFilter(groupId = null) {
      const filter = {
        attribute_key: 'name',
        filter_operator: 'equal_to',
        values: '',
        query_operator: 'and',
      };

      if (this.usesExplicitFilterGroups || groupId !== null) {
        filter.filter_group_id =
          groupId ?? lastFilterGroupId(this.appliedFilters);
      }

      return filter;
    },
    appendNewFilterToGroup(groupId = null) {
      if (this.isSegmentsView) {
        this.setQueryOperatorOnLastQuery(groupId);
        return;
      }

      this.appliedFilters.push(this.buildEmptyFilter(groupId));
    },
    appendNewFilterGroup() {
      const newGroupId = nextFilterGroupId(this.appliedFilters);
      const currentGroupId = lastFilterGroupId(this.appliedFilters);

      if (this.appliedFilters.length) {
        const lastIndex = this.appliedFilters.length - 1;

        this.appliedFilters = this.appliedFilters.map((filter, index) => {
          const normalizedFilter = assignFilterGroupId(
            filter,
            filter.filter_group_id ?? currentGroupId
          );

          if (index !== lastIndex) {
            return normalizedFilter;
          }

          return {
            ...normalizedFilter,
            query_operator: 'or',
          };
        });
      }

      this.appliedFilters.push(this.buildEmptyFilter(newGroupId));
    },
    appendNewAction() {
      if (!this.isActions) {
        this.appliedActions = [];
      }

      this.isActions = true;

      // Get first available action attribute dynamically
      const firstGroup = this.actionAttributeGroups?.[0];
      const firstAttribute = firstGroup?.attributes?.[0];

      if (!firstAttribute) return;

      const defaultAttribute = firstAttribute.key;

      const operators = this.getActionsOperators(defaultAttribute);
      const defaultOperator = operators?.[0]?.value || 'equal_to';

      const dropdownValues = this.getDropdownValues(defaultAttribute, {
        forActions: true,
      });

      const isMulti = ['assignee_id', 'labels_id'].includes(defaultAttribute);

      const noValueAction = ACTION_KEYS_WITHOUT_VALUES.includes(
        defaultAttribute
      );

      let defaultValue;
      if (noValueAction) {
        defaultValue = null;
      } else if (defaultAttribute === 'send_conversion_event') {
        defaultValue = this.defaultMetaCapiEventSelection();
      } else if (isMulti) {
        defaultValue = dropdownValues?.length ? [dropdownValues[0]] : [];
      } else {
        defaultValue = dropdownValues?.length ? dropdownValues[0] : null;
      }

      this.appliedActions.push({
        attribute_key: defaultAttribute,
        filter_operator: noValueAction ? 'is_present' : defaultOperator,
        values: isMulti ? [] : defaultValue,
        query_operator: 'and',
        attribute_model: 'standard',
      });
      this.normalizeSendConversionEventValues();
    },
  removeAction(index) {
  this.appliedActions.splice(index, 1);
  if (this.appliedActions.length === 0) {
    this.isActions = false;

  this.$store.dispatch(
    'contacts/setContactActions',
  JSON.parse(JSON.stringify([]))
  );

  }
},
  // resetAction(index, currentAction) {
  //   this.appliedActions[index].filter_operator = this.filterTypes.find(
  //     filter => filter.attributeKey === currentAction.attribute_key
  //   ).filterOperators[0].value;
  //   this.appliedActions[index].values = '';
  // },


  resetAction(index) {
    this.$nextTick(() => {
      const currentAction = this.appliedActions[index];
      if (!currentAction) return;

      const key = currentAction.attribute_key;

      if (ACTION_KEYS_WITHOUT_VALUES.includes(key)) {
        this.appliedActions[index].filter_operator = 'is_present';
        this.appliedActions[index].values = null;
        return;
      }

      if (key === 'send_conversion_event') {
        this.appliedActions[index].filter_operator = 'equal_to';
        this.appliedActions[index].values = this.defaultMetaCapiEventSelection();
        return;
      }

      if (key === 'send_ai_generated_email') {
        this.appliedActions[index].filter_operator = 'equal_to';
        this.appliedActions[index].values = defaultAiEmailActionValue();
        return;
      }

      const type = this.actionTypes.find(t => t.attributeKey === key);
      this.appliedActions[index].filter_operator =
        type?.filterOperators?.[0]?.value || 'equal_to';

      const isMulti = ['assignee_id', 'labels_id'].includes(key);
      this.appliedActions[index].values = isMulti ? [] : null;
    });
  },


    setQueryOperatorOnLastQuery(groupId = null) {
      const lastItemIndex = this.appliedFilters.length - 1;
      this.appliedFilters[lastItemIndex] = {
        ...this.appliedFilters[lastItemIndex],
        query_operator: 'and',
      };
      this.$nextTick(() => {
        this.appliedFilters.push(this.buildEmptyFilter(groupId));
      });
    },
    removeFilter(index) {
      if (this.appliedFilters.length <= 1) {
        this.showAlert(this.$t('CONTACTS_FILTER.FILTER_DELETE_ERROR'));
      } else {
        this.appliedFilters.splice(index, 1);
      }
    },
    isEmptyFilterValue(value) {
      if (value === null || value === undefined) return true;
      if (typeof value === 'string' && value.trim() === '') return true;
      if (Array.isArray(value) && value.length === 0) return true;
      if (Array.isArray(value)) {
        return value.every(item => {
          if (item === null || item === undefined) return true;
          if (typeof item === 'string' && item.trim() === '') return true;
          if (typeof item === 'object' && Object.keys(item).length === 0)
            return true;
          if (
            typeof item === 'object' &&
            item.id !== undefined &&
            (item.id === null || item.id === undefined || item.id === '')
          ) {
            return true;
          }
          return false;
        });
      }
      if (typeof value === 'object' && !Array.isArray(value)) {
        if (Object.keys(value).length === 0) return true;
        if (
          value.id !== undefined &&
          (value.id === null || value.id === undefined || value.id === '')
        ) {
          return true;
        }
      }
      return false;
    },
    hasValidFilterOrActionValue(item) {
      if (ACTION_KEYS_WITHOUT_VALUES.includes(item.attribute_key)) {
        return true;
      }

      if (item.attribute_key === 'send_conversion_event') {
        const v = item.values;
        if (!v || typeof v !== 'object') return false;
        const id = v.id != null ? String(v.id).trim() : '';
        const name = v.name != null ? String(v.name).trim() : '';
        return id.length > 0 || name.length > 0;
      }

      if (item.attribute_key === 'send_ai_generated_email') {
        return !aiEmailConfigErrorCode(item.values);
      }

      const operatorsWithoutValues = ['is_present', 'is_not_present'];
      if (operatorsWithoutValues.includes(item.filter_operator)) {
        return true;
      }

      return !this.isEmptyFilterValue(item.values);
    },
    validAppliedFilters() {
      return normalizeFilterGroupIds(
        this.appliedFilters.filter(item => this.hasValidFilterOrActionValue(item))
      );
    },
    validAppliedActions() {
      return (this.appliedActions || []).filter(item =>
        this.hasValidFilterOrActionValue(item)
      );
    },
    async confirmAppliedActions(validActions) {
      if (!validActions.length) return true;

      this.actionConfirmOpen = true;
      let confirmed = false;
      try {
        await this.$nextTick();
        if (!this.$refs.actionConfirmDialog) return false;
        confirmed = await this.$refs.actionConfirmDialog.showConfirmation();
      } finally {
        this.actionConfirmOpen = false;
      }
      return confirmed;
    },
    async submitFilterQuery() {
      if (this.actionConfirmOpen) return;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const validFilters = this.validAppliedFilters();
      const validActions = this.validAppliedActions();

      // If all filters are empty, don't submit (unless it's a segment view)
      if (validFilters.length === 0 && !this.isSegmentsView) {
        this.$emit('clearFilters');
        this.onClose();
        return;
      }

      const confirmed = await this.confirmAppliedActions(validActions);
      if (!confirmed) return;

      const filters = JSON.parse(JSON.stringify(validFilters));
      const actions = JSON.parse(JSON.stringify(validActions));
      const payload = {
        filters,
        actions,
        isActions: this.isActions && actions.length > 0,
      };

      this.$store.dispatch(
        'contacts/setContactFilters',
        JSON.parse(JSON.stringify(filters))
      );
      this.$store.dispatch(
        'contacts/setContactActions',
        JSON.parse(JSON.stringify(actions))
      );

      this.$emit('applyFilter', payload);
      this.$track(CONTACTS_EVENTS.APPLY_FILTER, {
        applied_filters: validFilters.map(filter => ({
          key: filter.attribute_key,
          operator: filter.filter_operator,
        })),
        applied_actions: validActions.map(action => ({
          key: action.attribute_key,
          operator: action.filter_operator,
        })),
      });
    },
    async updateSegment() {
      if (this.actionConfirmOpen) return;

      if (this.appliedActions?.length) {
        this.$v.appliedActions.$touch();
        if (this.$v.appliedActions.$invalid) return;
      }

      const validFilters = this.validAppliedFilters();
      const validActions = this.validAppliedActions();
      const confirmed = await this.confirmAppliedActions(validActions);
      if (!confirmed) return;

      const filters = JSON.parse(JSON.stringify(validFilters));
      const actions = JSON.parse(JSON.stringify(validActions));

      this.$emit('updateSegment', filters, this.activeSegmentNewName, {
        actions,
        isActions: this.isActions && actions.length > 0,
      });
    },
    resetFilter(index, currentFilter) {
      const type = this.filterTypes.find(
        filter => filter.attributeKey === currentFilter.attribute_key
      );
      if (!type) return;
      this.appliedFilters[index].filter_operator =
        type.filterOperators[0].value;
      this.appliedFilters[index].values = '';
    },
    showUserInput(operatorType, attributeKey = null) {
      if (ACTION_KEYS_WITHOUT_VALUES.includes(attributeKey)) return false;
      if (operatorType === 'is_present' || operatorType === 'is_not_present')
        return false;
      return true;
    },
    clearFilters() {
      this.$emit('clearFilters');
      this.onClose();
    },
  },
};
</script>
<style lang="scss" scoped>
.folder-input {
  @apply w-[50%];
}
.actions_box{
  margin-block: 9px;
}
.filter-group-container {
  @apply rounded-lg border border-solid border-slate-75 dark:border-slate-700/70 p-3;
}
.filter-group-label {
  @apply text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2;
}
.filter-group-connector {
  @apply relative flex items-center justify-center my-2.5 mx-0;
}
.filter-group-connector-line {
  @apply w-full absolute;
}
.filter-group-connector-select {
  @apply relative z-10;
}
.action-confirm-host {
  ::v-deep .modal-container {
    border-radius: 0.5rem;
    overflow: hidden;
  }
}
</style>
